<template>
  <div>
    <form  @submit.prevent="submit">
      <div class="row justify-content-center">
        <div class="col-sm-6 p-2" style="font-size:12px;">
          <div class="shadow p-3 rounded-lg">
            <p class="p-2 text-lg font-semibold"><span class="typcn typcn-pen"></span> LIST UNDANGAN</p>
            <hr class="mt-1 mb-1">
            <p class="text-sm">Tambah data : </p>
            <button type="button" @click="$router.push('/admin/nikah/mempelai')" class="btn btn-sm btn-primary "><span class="typcn typcn-group"></span> Mempelai</button>
            <button v-if="vdata.id" type="button" @click="$router.push(`/admin/nikah/galery?id=${vdata.id}`)" class="btn ml-3 btn-sm btn-dark"><span class="typcn typcn-image"></span> Galery</button>
            <button v-if="vdata.id" type="button" @click="$router.push(`/admin/nikah/acara?id=${vdata.id}`)" class="btn ml-3 btn-sm btn-danger"><span class="typcn typcn-archive"></span> Cara</button>
            <button v-if="vdata.id" type="button" @click="$router.push(`/admin/nikah/comment?id=${vdata.id}`)" class="btn ml-3 btn-sm btn-success"><span class="typcn typcn-message"></span> List Comment</button>
            <hr class="mt-1 mb-1">
          <!-- INPUT -->
          <div class="sm-form">
            <input
              type="text"
              id="id"
              name="id"
              class="form-control form-control-sm"
              placeholder="id"
              v-model="vdata.id"
              disabled
            />
          </div>
          <div class="table-responsive">
              <table class="table table-sm table-striped table-bordered">
                  <tr>
                      <td colspan="3">
                          <p class="p-2 font-semibold text-lg">Data Undangan Nikah : </p>
                      </td>
                  </tr>
                  <tr>        
                     <td class="capitalize">judul</td>
                     <td class="pl-2 pr-2">:</td>
                     <td>
                         <div class="sm-form ">
                             <input type="text" id="judul" name="judul" class="form-control form-control-sm" placeholder="judul" v-model="vdata.judul" >
                         </div>
                     </td>
                 </tr>
                   <tr>        
                      <td class="capitalize">mempelai</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                          <v-select :options="mempelais" label="item_data" v-model="vdata.mempelai" :reduce="e => e.id"></v-select>
                         
                      </td>
                  </tr>
                   <tr>        
                      <td class="capitalize">text tanggal</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                         <div class="sm-form">
                         <textarea type="text" id="text_tanggal" name="text_tanggal" rows="2" placeholder="ex : Kami akan menikah, dan kami ingin Anda menjadi bagian dari hari istimewa kami! ..." class="form-control md-textarea" v-model="vdata.text_tanggal"
                         ></textarea>
                         </div>
                      </td>
                  </tr>
                   <tr>        
                      <td class="capitalize">text invitation</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                         <div class="sm-form">
                         <textarea type="text" id="text_invitation" name="text_invitation" rows="2" placeholder="text_invitation..." class="form-control md-textarea" v-model="vdata.text_invitation"
                         ></textarea>
                         </div>
                      </td>
                  </tr>
                   <tr>        
                      <td class="capitalize">text penutup</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                         <div class="sm-form">
                         <textarea type="text" id="text_penutup" name="text_penutup" rows="2" placeholder="text_penutup..." class="form-control md-textarea" v-model="vdata.text_penutup"
                         ></textarea>
                         </div>
                      </td>
                  </tr>
                    <!-- <tr>        
                      <td class="capitalize">tanggal_akad</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                          <div class="sm-form ">
                              <input type="date" id="tanggal_akad" name="tanggal_akad" class="form-control form-control-sm" placeholder="tanggal_akad" v-model="vdata.tanggal_akad" >
                          </div>
                      </td>
                  </tr>
                    <tr>        
                      <td class="capitalize">jam_akad</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                          <div class="sm-form ">
                              <input type="text" id="jam_akad" name="jam_akad" class="form-control form-control-sm" placeholder="jam_akad" v-model="vdata.jam_akad" >
                          </div>
                      </td>
                  </tr>
                   <tr>        
                      <td class="capitalize">alamat_akad</td>
                      <td class="pl-2 pr-2">:</td>
                      <td>
                        <div class="sm-form">
                        <textarea type="text" id="alamat_akad" name="alamat_akad" rows="2" placeholder="alamat_akad..." class="form-control md-textarea" v-model="vdata.alamat_akad"
                        ></textarea>
                        </div>
                      </td>
                  </tr>
                  <tr>        
                        <td class="capitalize">lokasi_akad</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="text" id="lokasi_akad" name="lokasi_akad" class="form-control form-control-sm" placeholder="lokasi_akad" v-model="vdata.lokasi_akad" >
                            </div>
                        </td>
                    </tr> -->
                   <tr>        
                        <td class="capitalize">gambar pembuka</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="file" id="filenya1" name="gambar1" class="form-control form-control-sm" placeholder="gambar1" @change="upload1" >
                                <input type="text" id="gambar1" name="gambar1" class="form-control form-control-sm" placeholder="gambar1" v-model="vdata.gambar1" >
                                <img style="width:100px" v-viewer :src="vdata.gambar1" v-if="vdata.gambar1" alt="">
                            </div>
                        </td>
                    </tr>
                     <tr>        
                        <td class="capitalize">gambar penutup</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="file" id="filenya2" name="gambar2" class="form-control form-control-sm" placeholder="gambar2" @change="upload2" >
                                <input type="text" id="gambar2" name="gambar2" class="form-control form-control-sm" placeholder="gambar2" v-model="vdata.gambar2" >
                                <img style="width:100px" v-viewer :src="vdata.gambar2" v-if="vdata.gambar2" alt="">
                            </div>
                        </td>
                    </tr>
                     <tr>        
                        <td class="capitalize">background pertama</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="file" id="filenya3" name="gambar3" class="form-control form-control-sm" placeholder="gambar3" @change="upload3" >
                                <input type="text" id="gambar3" name="gambar3" class="form-control form-control-sm" placeholder="gambar3" v-model="vdata.gambar3" >
                                <img style="width:100px" v-viewer :src="vdata.gambar3" v-if="vdata.gambar3" alt="">
                            </div>
                        </td>
                    </tr>
                     <tr>        
                        <td class="capitalize">background undangan</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="file" id="filenya4" name="gambar4" class="form-control form-control-sm" placeholder="gambar4" @change="upload4" >
                                <input type="text" id="gambar4" name="gambar4" class="form-control form-control-sm" placeholder="gambar4" v-model="vdata.gambar4" >
                                <img style="width:100px" v-viewer :src="vdata.gambar4" v-if="vdata.gambar4" alt="">
                            </div>
                        </td>
                    </tr>
                    <tr>        
                        <td class="capitalize">media sosial gambar (setelah di upload ambil link dan gambar ke index.html meta og)</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="file" id="filenya5" name="gambar5" class="form-control form-control-sm" placeholder="gambar5" @change="upload5" >
                                <input type="text" id="gambar5" name="gambar5" class="form-control form-control-sm" placeholder="gambar5" v-model="vdata.gambar5" >
                                <img style="width:100px" v-viewer :src="vdata.gambar5" v-if="vdata.gambar5" alt="">
                            </div>
                        </td>
                    </tr>
                     <tr>        
                        <td class="capitalize">text1_color</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="color" id="text1_color" name="text1_color" class="form-control form-control-sm" placeholder="text1_color" v-model="vdata.text1_color" >
                            </div>
                        </td>
                    </tr>
                     <tr>        
                        <td class="capitalize">text2_color</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                            <div class="sm-form ">
                                <input type="color" id="text2_color" name="text2_color" class="form-control form-control-sm" placeholder="text2_color" v-model="vdata.text2_color" >
                            </div>
                        </td>
                    </tr>
                     
                     <tr>        
                        <td class="capitalize">animation</td>
                        <td class="pl-2 pr-2">:</td>
                        <td>
                        <v-select @input="cekanimation" :options="animrandom" v-model="vdata.animation" ></v-select>
                        <p v-if="anim" class="wow text-2xl font-semibold" 
                        :class="`${vdata.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:vdata.animation}`"
                        >ANIMATED</p>
                        <br>
                        <br>
                        <br>
                        </td>
                    </tr>
                    <!-- ================================================== -->
              </table>
          </div>
          <!-- END INPUT -->
          <!-- BUTTON PART -->
          <div class="mt-3 p-3">
            <button
              type="submit"
              class="btn btn-sm"
              :class="
                btn == 'tambah'
                  ? 'btn-primary'
                  : btn == 'update'
                  ? 'btn-success'
                  : 'btn-danger'
              "
            >
              <span class="typcn typcn-info"></span> Proses  {{ btn }}
            </button>
            <div class="float-right">
              <button
                type="button"
                v-show="btn!='tambah'"
                @click="
                  btn = 'tambah';
                  vdata = {};
                "
                class="btn btn-sm btn-dark"
              >
                <span class="typcn typcn-edit"></span> Tambah
              </button>
              <button
                type="button"
                @click="btn = 'delete'"
                v-show="btn!='tambah'"
                class="ml-3 btn btn-sm btn-danger"
              >
                <span class="typcn typcn-delete"></span> Delete
              </button>
            </div>
          </div>
          </div>
          <!-- END BUTTON PART -->
        </div>
        <div class="col-sm-6 p-2" style="font-size:12px;">
          <div class="shadow rounded-lg">
            <p class="p-2 text-lg font-semibold"><span class="typcn typcn-pen"></span> </p>
            <!-- TABLE PART -->
            <div v-if="datanya.length>0" class="p-2">
             <div class="text-right">
                <vue-json-excel :data="datanya">
                  <button type="button" class="btn btn-sm btn-dark">
                    Export <span class="typcn typcn-chart-area"></span>
                  </button>
                </vue-json-excel>
              </div>
                <Btables :tables="datanya"  :cari="['']" :hide="['jam_akad','alamat_akad','tanggal_akad','lokasi_akad']" @selected="ambil" ref="btable" />
            </div>
            <!-- END TABLE PART -->
         </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// TOTURIAL 
// ganti source autophp, ganti source component btable, ganti path table sdb
import autophp from "@/plugins/autophp.js"; // ganti source nya
import Btables from "@/components/Btables.vue"; //component btable nya
let sdb = new autophp();
let urlnya ='https://undangan.officialapp.website'
export default {
layout:'app_admin_undangan',
  components: {
    Btables,
  },
  data() {
    return {
      selected: false,
      vdata: {
          text_tanggal:'Kami akan menikah, dan kami ingin Anda menjadi bagian dari hari istimewa kami!',
          text_invitation:`Tanpa mengurangi rasa hormat,<br> kami mengundang Bapak/Ibu/Saudara/i untuk menghadiri pernikahan kami`,
          text_penutup:'Atas kehadiran dan do’a restu dari bapak/ibu/saudara/I sekalian, <br> kami mengucapkan Terima Kasih.'
      },
      btn: "tambah",
      datanya:[],
      mempelais:[],
      anim:true,
      animation:'animate__backInLeft',
      animrandom:[
        'animate__backInLeft',
        'animate__backInUp',
        'animate__backInDown',
        'animate__backInRight',
        'animate__bounceIn',
        'animate__bounceInUp',
        'animate__bounceInRight',
        'animate__bounceInLeft',
        'animate__bounceInDown',
        'animate__fadeIn',
        'animate__fadeInUp',
        'animate__fadeInDown',
        'animate__fadeInRight',
        'animate__fadeInLeft',
        'animate__flipInX',
        'animate__flipInY',
        'animate__rollIn',
        'animate__rotateIn',
        'animate__rotateInDownLeft',
        'animate__rotateInDownRight',
        'animate__rotateInUpLeft',
        'animate__rotateInUpRight',
        'animate__slideInDown',
        'animate__slideInUp',
        'animate__slideInRight',
        'animate__slideInLeft',
        'animate__zoomIn',
        'animate__zoomInUp',
        'animate__zoomInDown',
        'animate__zoomInRight',
        'animate__zoomInLeft',
      ],
    };
  },
  methods: {
    cekanimation(){
        this.anim=false;
        setTimeout(() => {
            this.anim=true;
        }, 500);
    },
    upload1(){
      let file = document.querySelector("#filenya1"); // berikan id pada input file
      sdb.collection('tbuser',false,urlnya).upload(file,true,true) // file,compress,scramble
      .then(res=>{
        this.vdata.gambar1=res;
        this.$forceUpdate();
      })
    },
    upload2(){
      let file = document.querySelector("#filenya2"); // berikan id pada input file
      sdb.collection('tbuser',false,urlnya).upload(file,true,true) // file,compress,scramble
      .then(res=>{
        this.vdata.gambar2=res;
        this.$forceUpdate();
      })
    },
     upload3(){
      let file = document.querySelector("#filenya3"); // berikan id pada input file
      sdb.collection('tbuser',false,urlnya).upload(file,true,true) // file,compress,scramble
      .then(res=>{
        this.vdata.gambar3=res;
        this.$forceUpdate();
      })
    },
     upload4(){
      let file = document.querySelector("#filenya4"); // berikan id pada input file
      sdb.collection('tbuser',false,urlnya).upload(file,true,true) // file,compress,scramble
      .then(res=>{
        this.vdata.gambar4=res;
        this.$forceUpdate();
      })
    },
     upload5(){
      let file = document.querySelector("#filenya5"); // berikan id pada input file
      sdb.collection('tbuser',false,urlnya).upload(file,false,true) // file,compress,scramble
      .then(res=>{
        this.vdata.gambar5=res;
        this.$forceUpdate();
      })
    },
    getData(){
      sdb.collection("app_undangan_nikah",false,urlnya).doc().select(`select * from app_undangan_nikah`).then(res => {
        this.datanya=res;
        this.$forceUpdate();
      });
      sdb.collection("app_undangan_nikah_mempelai",false,urlnya).doc().select(`select * from app_undangan_nikah_mempelai`).then(res => {
          this.mempelais=res;
           this.mempelais.map(function (x){ // taruh setelah produks di initial
                return x.item_data = x.nama_lengkap1 + ' - ' + x.nama_lengkap2;
            });
          this.$forceUpdate();
      });
      
    },
    ambil(data) {
      this.vdata = data;
      this.btn = "update";
      this.$forceUpdate();
    },
    async submit() {
      let that=this
      if (confirm("Apakah yakin proses dilanjutkan ?")) {
        if (this.btn == "tambah") {
          delete this.vdata.id;
          await sdb
            .collection("app_undangan_nikah",true,urlnya)
            .doc()
            .set(this.vdata)
              that.getData();
        } else if (this.btn == "update") {
         await sdb
            .collection("app_undangan_nikah",true,urlnya)
            .doc()
            .set(this.vdata)
              that.getData();
        } else if (this.btn == "delete") {
          await sdb
            .collection("app_undangan_nikah",true,urlnya)
            .doc(this.vdata.id)
            .delete()
              that.getData();
        }
      }
    },
  },
  async mounted() {
          this.getData();
  },
};
</script>